import { PROCESS } from "../../lib/content";
import { Reveal, Eyebrow } from "../Reveal";

export const Process = () => (
  <section id="process" data-testid="process" className="bg-secondary text-secondary-foreground py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <Eyebrow className="text-primary">How it works</Eyebrow>
        <h2 className="font-display text-5xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4">
          Simple from
          <span className="italic"> quote to check-out.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 border-t border-white/15">
        {PROCESS.map((p, i) => (
          <Reveal
            key={p.n}
            delay={i * 0.08}
            className="border-b md:border-b-0 md:border-r border-white/15 last:border-r-0 py-10 md:py-12 md:pr-8 md:pl-6 first:md:pl-0 group"
          >
            <span className="font-display text-primary text-6xl md:text-7xl font-light block mb-6 group-hover:translate-x-1 transition-transform duration-500">
              {p.n}
            </span>
            <h3 className="font-display text-2xl md:text-3xl font-normal mb-3">{p.title}</h3>
            <p className="text-white/65 text-sm md:text-base font-light leading-relaxed">{p.copy}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
